import React from "react";
import { cn } from "@/lib/utils";

interface TwoContainersSkeletonProps {
  className?: string;
}

const TwoContainersSkeleton: React.FC<TwoContainersSkeletonProps> = ({
  className,
}) => {
  return (
    <div className={cn("space-y-4", className)}>
      <div className="h-[225px] w-full animate-pulse rounded-md bg-primary/10" />
      <div className="h-[195px] w-full animate-pulse rounded-md bg-primary/10" />
    </div>
  );
};

export default TwoContainersSkeleton;
